import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PropTypes } from "prop-types";
import imgLogo from "../../../../../image/logo.png";
import api from "../../../../../utils/apidsf";
import swal from "sweetalert";
import { useDispatch, useSelector } from "react-redux";
import { GetToken } from "../../../../../actions/userAction.js";

import "./CreateSyllabus.css";

// components
import FormField from "../../../Components/FormField/FormField";
import { RichTextEditor } from "@mantine/rte";

export default function CreateSyllabus() {
  const params = useParams();
  const dispatch = useDispatch();

  const selector = useSelector((state) => state);
  const navigate = useNavigate();
  //const [id, setId] = useState("");
  // const [textareadata, settextdata] = useState({
  //   value: RichTextEditor.createEmptyValue(),
  // });
  const [filetoken, setfiletoken] = useState("");
  const [formData, setFormData] = useState({
    title: "",
    subject: "",
    state: "",
    university: "",
    exam: "",
    year: "",
    ugc_subject: "",
    description: "",
    rawPdf: [],
    pdf: "",
  });
  const [show, setShow] = useState({
    showState: false,
    showYear: false,
    showUni: false,
    showExam: false,
    loading: false,
    examSelect: false,
    ugcSubject: false,
    showllbExam: false,
  });
  const [showPdf, setShowPdf] = useState(false);

  useEffect(() => {
    dispatch(GetToken());
  }, []);
  useEffect(() => {
    setfiletoken(selector?.adminReducer?.token);
  }, [selector]);

  const handleInputChange = (e) => {
    setFormData((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let id = params.id;
    let token = JSON.parse(localStorage.getItem("token"));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    const createOrUpdateLandmarkWithOutFile = async () => {
      try {
        let res = null;
        if (id) {
          res = await api.put(`/syllabus-admin/${id}`, formData, config);
        } else {
          res = await api.post("/syllabus-admin/", formData, config);
        }
        const data = res.data.data;

        if (data && id) {
          swal({
            title: "Syllabus Updated",
            text: "Syllabus Updated Successfully",
            icon: "success",
          });
          navigate("/admin/syllabus-table");
        } else {
          setFormData({
            ...formData,
            title: "",
            description: "",
            rawPdf: [],
          });
          swal({
            title: "Syllabus Added",
            text: "Syllabus Added Successfully",
            icon: "success",
          });
          // show error
        }
      } catch (err) {
        console.error(err.response.data.error);
        swal({
          title: "Error",
          text: err.response.data.error,
          icon: "error",
        });
      }
    };
    const createOrUpdateLandmarkWithFile = async () => {
      const form = new FormData();
      form.append("file", formData?.rawPdf);
      await fetch("https://assets.thelexpedia.com//wp-json/wp/v2/media", {
        method: "POST",
        headers: {
          Authorization: `Bearer  ${filetoken}`,
        },
        body: form,
      })
        .then((res) => res.json())
        .then(async (data) => {
          console.log(data);
          const input = {
            profile_image: data.source_url,
          };
          //send image url to backend

          // let formData = {
          //   title: formData?.title,
          //   state: formData?.state,
          //   rawPdf: formData?.rawPdf,
          //   pdf: data.source_url,
          //   description: formData?.description,
          //   RechtextforDescription: formData?.RechtextforDescription,
          // };

          formData.pdf = data.source_url;
          console.log(formData);

          try {
            let res = null;
            let token = JSON.parse(localStorage.getItem("token"));

            const config = {
              headers: {
                "Content-Type": "application/json",
                Authorization: token,
              },
            };
            if (id) {
              res = await api.put(`/syllabus-admin/${id}`, formData, config);
            } else {
              res = await api.post("/syllabus-admin/", formData, config);
            }
            const data = res.data.data;
            console.log(data);
            if (data && id) {
              swal({
                title: "Syllabus Updated",
                text: "Syllabus Updated Successfully",
                icon: "success",
              });
              navigate("/admin/syllabus-table");
            } else {
              setFormData({
                ...formData,
                title: title,
                subject: subject,
                state: state,
                university: university,
                exam: exam,
                year: year,
                ugc_subject: ugc_subject,
                description: "",
                rawPdf: [],
              });
              swal({
                title: "Syllabus Added",
                text: "Syllabus Added Successfully",
                icon: "success",
              });
              // show error
            }
          } catch (err) {
            console.error(err.response.data.error);

            swal({
              title: "Error",
              text: err.response.data.error,
              icon: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    try {
      if (formData?.rawPdf?.length !== 0) {
        createOrUpdateLandmarkWithFile();
      } else {
        createOrUpdateLandmarkWithOutFile();
      }
    } catch (err) {
      console.error(err.response.data.error);
      swal({
        title: "Error",
        text: err.response.data.error,
        icon: "error",
      });
    }
  };

  useEffect(() => {
    let id = params.id;
    let token = JSON.parse(localStorage.getItem("token"));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    const fetchLandmark = async () => {
      const res = await api.get(`/syllabus-admin/${id}`, config);
      const data = res.data.data;
      console.log(data);
      const {
        title,
        state,
        university,
        exam,
        year,
        ugc_subject,
        subject,
        description,
        pdf,
      } = data;
      checkSelectValue(subject);
      setFormData((pre) => {
        return {
          ...pre,
          subject: subject,
          title: title,
          state: state,
          university: university,
          exam: exam,
          year: year,
          ugc_subject: ugc_subject,
          pdf: pdf,
        };
      });

      setFormData((prev) => {
        return {
          ...prev,
          description: description,
        };
      });
    };

    if (id) {
      setShowPdf(true);
      fetchLandmark();
    } else {
      setFormData({
        title: "",
        subject: "",
        state: "",
        university: "",
        exam: "",
        year: "",
        ugc_subject: "",
        description: "",
        rawPdf: [],
        pdf: "",
      });
      setShowPdf(false);
    }
  }, [params]);

  const checkUgcSubject = (data) => {
    switch (data) {
      case "Paper Two":
        setShow({
          ...show,
          ugcSubject: true,
        });
        break;
      default:
        setShow({
          ...show,
          ugcSubject: false,
        });
    }
  };

  const checkSelectValue = (data) => {
    switch (data) {
      case "Judiciary":
        setShow({
          ...show,
          showState: true,
          showllbExam: false,
          showYear: true,
          showUni: false,
          showExam: false,
          examSelect: false,
          ugcSubject: false,
        });
        break;
      case "ADA/APP/APO/JLO":
        setShow({
          ...show,
          showState: true,
          showYear: true,
          showllbExam: false,
          showUni: false,
          showExam: false,
          examSelect: false,
          ugcSubject: false,
        });
        break;
      case "UGC NET":
        setShow({
          ...show,
          showState: false,
          showYear: true,
          showUni: false,
          showllbExam: false,
          showExam: false,
          examSelect: true,
          ugcSubject: false,
        });
        break;
      case "LLB Entrance":
        setShow({
          ...show,
          showState: false,
          showYear: true,
          showUni: false,
          showllbExam: true,
          showExam: false,
          examSelect: false,
          ugcSubject: false,
        });
        break;
      case "LLM Entrance":
        setShow({
          ...show,
          showState: false,
          showYear: true,
          showUni: false,
          showExam: false,
          showllbExam: true,
          examSelect: false,
          ugcSubject: false,
        });
        break;
      case "Phd in Law":
        setShow({
          ...show,
          showState: false,
          showYear: true,
          showllbExam: false,
          showUni: true,
          showExam: false,
          examSelect: false,
          ugcSubject: false,
        });
        break;
      case "AIBE":
        setShow({
          ...show,
          showState: false,
          showYear: true,
          showUni: false,
          showllbExam: false,
          showExam: false,
          examSelect: false,
          ugcSubject: false,
        });
        break;
      case "Law Officer":
        setShow({
          ...show,
          showState: false,
          showYear: false,
          showllbExam: false,
          showUni: false,
          showExam: true,
          examSelect: false,
          ugcSubject: false,
        });
        break;
      default:
        setShow({
          ...show,
          showState: false,
          showYear: false,
          showllbExam: false,
          showUni: false,
          showExam: false,
          examSelect: false,
          ugcSubject: false,
        });
    }
  };

  useEffect(() => {
    if (formData.exam == "Paper Two") {
      setShow({
        ...show,
        showState: show.showState,
        showYear: show.showYear,
        showUni: show.showUni,
        showExam: show.showExam,
        examSelect: show.examSelect,
        showUni: show.showUni,
        ugcSubject: true,
      });
    }

    if (formData.exam == "University") {
      setShow({
        ...show,
        showState: show.showState,
        showYear: show.showYear,
        showUni: true,
        showllbExam: show.showllbExam,
        showExam: show.showExam,
        examSelect: show.examSelect,
        ugcSubject: show.ugcSubject,
      });
    }
  }, [formData]);

  const onChange = (value) => {
    setFormData({
      ...formData,
      description: value,
    });
  };
  const {
    title,
    subject,
    state,
    university,
    exam,
    year,
    ugc_subject,
    description,
    pdf,
  } = formData;
  return (
    <div style={{ flex: 4 }}>
      <form action="" className="admin__userUpdateForm" onSubmit={handleSubmit}>
        <div className="userUpdateLeft">
          <FormField
            type="text"
            label="Title"
            placeholder="Title"
            value={title}
            name="title"
            handleChange={handleInputChange}
          />

          <div className="userUpdateItem">
            <label className="user__label">Subject</label>
            <select
              value={subject}
              onChange={(e) => {
                checkSelectValue(e.target.value);
                setFormData({
                  ...formData,
                  subject: e.target.value,
                });
              }}
            >
              <option value=" ">Select Subject</option>
              <option value="Judiciary">Judiciary</option>
              <option value="ADA/APP/APO/JLO">ADA/APP/APO/JLO</option>
              <option value="UGC NET">UGC NET</option>
              <option value="LLB Entrance">LLB Entrance</option>
              <option value="LLM Entrance">LLM Entrance</option>
              <option value="Phd in Law">Phd in Law</option>
              <option value="AIBE">AIBE</option>
              <option value="Law Officer">Law Officer</option>
            </select>
          </div>

          {show.examSelect ? (
            <div className="userUpdateItem">
              <label className="user__label">Exam</label>
              <select
                value={exam}
                onChange={(e) => {
                  checkUgcSubject(e.target.value);
                  setFormData({
                    ...formData,
                    exam: e.target.value,
                  });
                }}
              >
                <option value=" ">Select Exam</option>
                <option value="Paper One">Paper One</option>
                <option value="Paper Two">Paper Two</option>
              </select>
            </div>
          ) : (
            ""
          )}

          {show.ugcSubject ? (
            <div className="userUpdateItem">
              <label className="user__label">UGC Subject</label>
              <select
                value={ugc_subject}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    ugc_subject: e.target.value,
                  });
                }}
              >
                <option value=" ">Select Subject</option>
                <option value="Law">Law</option>
              </select>
            </div>
          ) : (
            ""
          )}

          {show.showllbExam ? (
            <div className="userUpdateItem">
              <label className="user__label">Exam</label>
              <select
                value={exam}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    exam: e.target.value,
                  });

                  if (e.target.value == "University") {
                    setShow({
                      ...show,
                      showUni: true,
                    });
                  }
                }}
              >
                <option value="">Select Exam</option>
                <option value="CLAT">CLAT</option>
                <option value="LSAT">LSAT</option>
                <option value="University">University</option>
              </select>
            </div>
          ) : (
            ""
          )}

          {show.showState ? (
            <FormField
              type="text"
              label="State"
              placeholder="State"
              value={state}
              name="state"
              handleChange={handleInputChange}
            />
          ) : (
            ""
          )}

          {show.showUni ? (
            <FormField
              type="text"
              label="University"
              placeholder="University"
              value={university}
              name="university"
              handleChange={handleInputChange}
            />
          ) : (
            ""
          )}

          {show.showExam ? (
            <FormField
              type="text"
              label="Exam"
              placeholder="Exam"
              value={exam}
              name="exam"
              handleChange={handleInputChange}
            />
          ) : (
            ""
          )}

          {show.showYear ? (
            <FormField
              type="number"
              label="Year"
              placeholder="Year"
              value={year}
              name="year"
              handleChange={handleInputChange}
            />
          ) : (
            ""
          )}

          <div className="userUpdateItem">
            <label className="user__label">PDF</label>
            {showPdf ? (
              <div className="divCssEditPdf">
                <a href={pdf} target="_blank">
                  Click to See Pdf
                </a>
                <button
                  type="button"
                  className="pdfButtonCss"
                  onClick={() => setShowPdf(false)}
                >
                  Edit
                </button>
              </div>
            ) : (
              <input
                type="file"
                name="pdf"
                id="pdf"
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    rawPdf: e.target.files[0],
                  });
                  console.log(e.target.files[0]);
                }}
              />
            )}
          </div>

          <div className="userUpdateItem">
            <label className="user__label">Description</label>

            <RichTextEditor
              className="desc_area height_xl"
              value={description}
              onChange={onChange}
            />
          </div>

          <div>
            <button className="userUpdateButton" type="submit">
              {params.id ? "Update  Syllabus" : "Add Syllabus"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
